var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.65172 19.56402h17v42.43598h-17z",
    fill: "#5aaae0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.86231 19.56402h17.13769v42.43598h-17.13769z",
    fill: "#5aaae0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.65172 2h26.21059v60h-26.21059z",
    fill: "#7dc7ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m33.91175 48.56612a3.92331 3.92331 0 0 0 1.89386-3.34312 4.00035 4.00035 0 0 0 -8 0 3.92331 3.92331 0 0 0 1.89386 3.34313 5.92185 5.92185 0 0 0 -3.89386 5.53881v7.89506h12v-7.89507a5.92183 5.92183 0 0 0 -3.89386-5.53881z",
    fill: "#f73445"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#359ed8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.68412 23.51155h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.68412 27.45909h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.68412 31.40662h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.68412 35.35415h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71652 23.51155h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71652 27.45909h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71652 31.40662h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71652 35.35415h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.74892 23.51155h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.74892 27.45909h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.74892 31.40662h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.74892 35.35415h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.78132 23.51155h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71652 19.56402h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.74892 19.56402h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.78132 19.56402h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.78132 27.45909h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.78132 31.40662h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.78132 35.35415h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.81371 23.51155h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.81371 27.45909h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.81371 31.40662h2.0162v1.97377h-2.0162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.81371 35.35415h2.0162v1.97377h-2.0162z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.46982 52.48462a2.93085 2.93085 0 0 0 1.16571-2.32722 3.00026 3.00026 0 0 0 -6 0 2.93082 2.93082 0 0 0 1.16571 2.32722 4.92935 4.92935 0 0 0 -3.16571 4.581v4.93438h10v-4.93442a4.92936 4.92936 0 0 0 -3.16571-4.58096z",
    fill: "#f7f769"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22.54271 49.524a2.93082 2.93082 0 0 0 1.16571-2.32722 3.00026 3.00026 0 0 0 -6 0 2.93082 2.93082 0 0 0 1.16571 2.32722 4.92936 4.92936 0 0 0 -3.16571 4.581v7.895h10v-7.89507a4.92936 4.92936 0 0 0 -3.16571-4.58093z",
    fill: "#ffc943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53.79379 52.48462a2.93082 2.93082 0 0 0 1.16571-2.32722 3.00026 3.00026 0 0 0 -6 0 2.93082 2.93082 0 0 0 1.16571 2.32722 4.92936 4.92936 0 0 0 -3.16571 4.581v4.93438h10v-4.93442a4.92935 4.92935 0 0 0 -3.16571-4.58096z",
    fill: "#f7f769"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m44.7209 49.524a2.93082 2.93082 0 0 0 1.16571-2.32722 3.00026 3.00026 0 0 0 -6 0 2.93082 2.93082 0 0 0 1.16571 2.32722 4.92935 4.92935 0 0 0 -3.16571 4.581v7.895h10v-7.89507a4.92936 4.92936 0 0 0 -3.16571-4.58093z",
    fill: "#ffc943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49.90281 26.4722h2.0162v15.79013h-2.0162z",
    fill: "#005889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m55.9514 26.4722h2.0162v15.79013h-2.0162z",
    fill: "#005889"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.54643 26.4722h2.0162v15.79013h-2.0162z",
    fill: "#005889"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m11.59503 26.4722h2.0162v15.79013h-2.0162z",
    fill: "#005889"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m23.69222 4.76077h16.12959v9.86883h-16.12959z",
    fill: "#359ed8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/empresa.8102446619a8e91a80c654a034a16b74.svg";
export { ForwardRef as ReactComponent };